import { MockHook } from '@jupiterone/jupiter-web-toolkit';
export interface SearchAnywhereIconProps {
  searchAnywhereOpen: boolean;
  handleSearchAnywhereToggle: VoidFunction;
}
const useSearchAnywhereIconLogic = ({
  searchAnywhereOpen,
  handleSearchAnywhereToggle,
}: SearchAnywhereIconProps) => {
  return {
    searchAnywhereOpen,
    handleSearchAnywhereToggle,
  };
};

export type SearchAnywhereIconComponentProps = ReturnType<
  typeof useSearchAnywhereIconLogic
>;
export const MOCK_SEARCH_ANYWHERE_ICON_PROPS: SearchAnywhereIconComponentProps = {
  searchAnywhereOpen: MockHook.mockFunction,
  handleSearchAnywhereToggle: MockHook.mockFunction,
};
export default MockHook.useMockHook(
  useSearchAnywhereIconLogic,
  MOCK_SEARCH_ANYWHERE_ICON_PROPS
);
